import React, { useState } from "react";
import {
  Grid,
  Menu,
  Accordion,
  Segment,
  Input
} from "semantic-ui-react";
import ServerStatus from "./ServerStatus";
// import Draggable from "react-draggable"

const getTheNameFromTheHole = root => {
  if (typeof root.children === "string") {
    return root.children;
  } else {
    return getTheNameFromTheHole(root.children.props);
  }
};

const ContentGrid = (props) => {
  const { content, menu, accordion, loading } = props;

  const [activeIndex, setActiveIndex] = useState("")
  const [filtered, setFiltered] = useState([])
  const [height] = useState(0)

  // For basic menu onClick handler
  const handleSideMenu = (e, { name }) => setActiveIndex(name);

  // For accordion menu onClick handler
  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex)
  };

  const handleSearchFilter = (event, { name, value }) => {
    const index = menu.findIndex(item => item.content === name);
    const menuItems = menu[index].items;
    const filteredList = menuItems.filter(item =>
      getTheNameFromTheHole(item.props).includes(value)
    );

    let filtered = [];
    filtered[index] = filteredList;
    setFiltered(filtered)
  };

  const getHeight = () => {
    const newHeight = height - 400;
    if (newHeight < 1) {
      return 500;
    } else {
      return newHeight;
    }
  };

  const renderMenu = () => {
    if (accordion) {
      return (
        <Accordion as={Menu} fluid vertical>
          {menu.map((menuItem, index) => (
            <Menu.Item key={index}>
              <Accordion.Title
                active={activeIndex === index}
                content={menuItem.content}
                index={index}
                onClick={handleClick}
              />
              <Accordion.Content active={activeIndex === index}>
                <Input
                  name={menuItem.content}
                  placeholder="Search..."
                  fluid
                  onChange={handleSearchFilter}
                />
                <Menu.Item
                  style={{
                    maxHeight: `${getHeight()}${"px"}`,
                    flex: 1,
                    minHeight: "500px",
                    overflow: "auto"
                  }}
                >
                  {filtered[index] || menuItem.items}
                </Menu.Item>
              </Accordion.Content>
            </Menu.Item>
          ))}
        </Accordion>
      );
    } else {
      return (
        <Menu vertical fluid>
          {menu.map((element, index) => {
            const name = element.props.children || element;
            const selector = element.props.href || null;
            return (
              <Menu.Item
                // name={name}
                color="blue"
                onClick={handleSideMenu}
                active={activeIndex === name}
                key={index}
                href={selector}
              >
                {name}
              </Menu.Item>
            );
          })}
        </Menu>
      );
    }
  };

  return (
    <Segment basic style={{ margin: "0px 0px 0px 0xp" }}>
      <Grid stackable columns={2}>
        <Grid.Row>
          <Grid.Column
            className="reference"
            width={12}
            style={{ paddingTop: "30px", paddingBottom: "30px" }}
          >
            <div /* ref={divElement => (this.divElement = divElement)} */>
              {loading || !content ? null : content}
            </div>
          </Grid.Column>
          <Grid.Column
            width={4}
            style={{ padding: "20px" }}
            only="large screen computer tablet"
          >
            {loading ? <Segment loading={loading} style={{ height: "75px" }} /> : renderMenu()}
            <ServerStatus />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

export default ContentGrid;
